/* unplugin-vue-components disabled */import script from "./CardList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardList.vue?vue&type=script&lang=ts&setup=true"

import "./CardList.vue?vue&type=style&index=0&id=31023bc9&lang=less&scoped=true"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31023bc9"]])

export default __exports__